import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.AnnouncementsPage.title',
    defaultMessage: 'Announcements',
  },
  subtitle: {
    id: 'containers.AnnouncementsPage.subtitle',
    defaultMessage: 'Chronological announcement history for all in-house software and platforms.',
  },
  new: {
    id: 'containers.AnnouncementsPage.new',
    defaultMessage: 'New',
  },
  featureFlagLink: {
    id: 'containers.AnnouncementsPage.featureFlagLink',
    defaultMessage: 'Go to settings to enable feature',
  },
  createAnnouncement: {
    id: 'containers.AnnouncementsPage.createAnnouncement',
    defaultMessage: 'Create announcement',
  },
  columnTitle: {
    id: 'containers.AnnouncementsPage.columnTitle',
    defaultMessage: 'Title',
  },
  columnUserType: {
    id: 'containers.AnnouncementsPage.columnUserType',
    defaultMessage: 'User type',
  },
  columnPartner: {
    id: 'containers.AnnouncementsPage.columnPartner',
    defaultMessage: 'Partner',
  },
  columnTags: {
    id: 'containers.AnnouncementsPage.columnTags',
    defaultMessage: 'Tags',
  },
  columnDate: {
    id: 'containers.AnnouncementsPage.columnDate',
    defaultMessage: 'Date',
  },
  userTypeCustomer: {
    id: 'containers.AnnouncementsPage.userTypeCustomer',
    defaultMessage: 'Customer',
  },
  userTypeSupplier: {
    id: 'containers.AnnouncementsPage.userTypeSupplier',
    defaultMessage: 'Supplier',
  },
  deleteConfirm: {
    id: 'containers.AnnouncementsPage.deleteConfirm',
    defaultMessage: 'Delete',
  },
})
